import { render, staticRenderFns } from "./CalendarDayItemCompact.vue?vue&type=template&id=027e0c46&"
import script from "./CalendarDayItemCompact.vue?vue&type=script&lang=js&"
export * from "./CalendarDayItemCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports